<script lang="ts" setup>
  import footerLinks from '#shared/data/footerLinks';
  import socialNetworks from '#shared/data/socialNetworks';

  const links = ref(footerLinks);
  const socials = ref(socialNetworks);

  const hasAuthUser = ref(!!stores.user.getUser());

  watchEffect(async () => {
    hasAuthUser.value = !stores.user.isLoggedIn;
    await nextTick();
    hasAuthUser.value = !!stores.user.isLoggedIn;
  });

  const currentYear = new Date().getUTCFullYear();
</script>

<template>
  <footer
    class="contain-content flex flex-col items-center gap-6 mt-auto -mx-2.5 mb-[4.375rem] md:mb-3 py-10 rounded-md relative z-20"
    :class="{
      'max-md:bg-white/5 max-md:backdrop-blur-[25px]': hasAuthUser,
    }"
  >
    <div class="flex flex-col gap-6 items-center md:flex-row md:gap-9">
      <NuxtLink
        v-for="link in links"
        :key="link.to"
        :to="link.to"
        :data-test-id="link.testId"
        :prefetch="false"
        class="text-white font-barlow hover:text-primary transition-colors duration-200 ease-in-out text-[15px] font-medium leading-none"
      >
        {{ link.label }}
      </NuxtLink>
    </div>

    <div class="w-full h-[1px] bg-white/10 md:hidden" />

    <div class="flex items-center justify-center gap-4">
      <NuxtLink
        v-for="social in socials"
        :key="social.to"
        :to="social.to"
        :data-test-id="social.testId"
        :aria-label="`${social.label} link`"
        target="_blank"
        rel="noopener"
        class="rounded-[10px] border border-white/30"
      >
        <component :is="`Svgo${social.icon}`" class="size-10" />
      </NuxtLink>
    </div>

    <div class="w-full h-[1px] bg-white/10" />

    <div class="flex flex-col items-center text-white font-barlow">
      <p class="text-sm md:text-base leading-normal">© {{ currentYear }} MAXDUEL. ALL RIGHTS RESERVED.</p>
    </div>
  </footer>
</template>
